const toggleHeaderColor = (options?: {
	target?: Element;
	className?: string;
	threshold?: number;
	root?: Window | HTMLElement;
}) => {
	const {
		target = document.body,
		className = "is-scrolled",
		threshold = 1,
		root = window,
	} = options ?? {};

	let ticking = false;

	const getScrollTop = (): number => {
		if (root === window) {
			return window.scrollY || document.documentElement.scrollTop || 0;
		}
		return (root as HTMLElement).scrollTop;
	};

	const update = () => {
		const y = getScrollTop();
		target.classList.toggle(className, y >= threshold);
		ticking = false;
	};

	const onScroll = () => {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(update);
	};

	root.addEventListener("scroll", onScroll, { passive: true });

	return () => {
		root.removeEventListener("scroll", onScroll as EventListener);
	};
};
export default toggleHeaderColor;
